export function filterForScenario(data, scenario = "control") {
    const preferences = data.questionnaire.preferences

    const indexMap = {}
    for (let pref of preferences) {
        if (!indexMap[pref.order]) {
            indexMap[pref.order] = []
        }
        indexMap[pref.order].push(pref);
    }

    const filter = (p => p.scenario === scenario)

    for (let [order, prefs] of Object.entries(indexMap)) {
        if (prefs.length > 1) {
            const scenarioOverride = prefs.filter(filter)
            if (scenarioOverride.length) {
                indexMap[order] = scenarioOverride[0]
            } else {
                indexMap[order] = prefs.find(p=>p.scenario === 'control')
                    || prefs[0]
            }
        } else {
            indexMap[order] = prefs[0];
        }
    }

    return Object.values(indexMap)
}
